import { createFileRoute } from '@tanstack/react-router';
import { useFlagsStatus } from '@unleash/proxy-client-react';

import ExploreEventsListing from '@/components/_events/ExploreEventsListing.tsx';
import ExplorePage from '@/components/_explore/ExplorePage.tsx';
import { ExploreLayout } from '@/components/layouts/index.tsx';
import PageLoading from '@/components/loading/PageLoading.tsx';
import PageDisabled from '@/components/PageDisabled.tsx';
import useFlag from '@/lib/hooks/useFlag.ts';

const Lobby = () => {
  const featuresReady = useFlagsStatus().flagsReady;
  const enableExplore = useFlag('explore.lobby');

  if (!featuresReady) {
    return <PageLoading />;
  }
  if (!enableExplore) {
    return <PageDisabled absolutelyCentered />;
  }

  return (
    <ExplorePage isSubPage title="explore:lobby">
      <ExploreEventsListing types={['lobby']} />
    </ExplorePage>
  );
};

export const Route = createFileRoute('/explore/lobby')({
  component: () => (
    <ExploreLayout title="explore:lobby">
      <Lobby />
    </ExploreLayout>
  ),
});
